import { format } from 'date-fns';

import { Heading } from '../../../typography/heading/Heading';
import { Text } from '../../../typography/text/Text';
import { theme } from './_vars';
import styles from './ArticleHeading.module.scss';

import { Author } from '@srcDS/js/components/templates/journal/journalArticle/JournalArticle';

export interface ArticleHeadingProps {
  author?: Author;
  title?: string;
  description?: string;
  publishedDate?: string;
  lineColor?: string;
  hideDescription?: boolean;
}

const ArticleHeading: React.FC<ArticleHeadingProps> = ({
  author,
  title,
  description,
  publishedDate,
  lineColor = '#FAFFC7',
  hideDescription,
}) => {
  const formattedDate = publishedDate ? format(new Date(publishedDate), 'd MMM yyyy') : null;

  return (
    <div style={{ '--line-color': lineColor } as React.CSSProperties} className={styles.container}>
      {title && (
        <Heading as="h1" align={theme === 'sportscraft' ? 'left' : 'center'} className={styles.title}>
          {title}
        </Heading>
      )}

      <div className={styles.authorBlock}>
        {formattedDate && (
          <Text
            weight={theme === 'saba' ? 'light' : 'normal'}
            align={theme === 'sportscraft' ? 'left' : 'center'}
            className={styles.publishedDate}
            size="xs"
            as="p"
          >
            {formattedDate}
          </Text>
        )}
        {author && (
          <Text
            weight={theme === 'saba' ? 'light' : 'normal'}
            align={theme === 'sportscraft' ? 'left' : 'center'}
            className={styles.authorName}
            size="xs"
            as="p"
          >
            {theme === 'sportscraft' && `Author: `}
            {author?.firstName} {author?.lastName}
          </Text>
        )}
      </div>

      {!hideDescription && description && (
        <Text
          weight={theme === 'saba' ? 'light' : 'normal'}
          align={theme === 'sportscraft' ? 'left' : 'center'}
          size="sm"
          as="p"
          className={styles.description}
        >
          {description}
        </Text>
      )}
    </div>
  );
};

export default ArticleHeading;
